<template>
    <div class="view-body view-body--module">
      <div class="view-data">
        <div class="view-data__header view-data__header--module">
          <h1>{{title}} {{subTitle}} ({{tableCount}})</h1>
          <div v-if="type == 'page'" class="page-status-container">
            <!--<p v-if="!historyMode">Status strony nr {{findPage(true)}}</p>
            <pageStatus :page="findPage()" :order="orderMain" :historyMode="historyMode" :blocked="blocked"/>-->
          </div>
        </div>
        <div class="data-table__head data-table__head--module">
            <div class="data-table-sort">
              <p>Pokaż</p>
              <select v-model="perPage">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <p>pozycji</p>
            </div>
            <div class="button-group">
              <!--<span v-if="type !== 'trash'" class="button-module-table" :class="{'disabled' : historyMode || blocked }" @click="generateReport()">
                <svg viewBox="0 0 21 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-1504.000000, -212.000000)" fill="#E3000B" fill-rule="nonzero">
                            <g transform="translate(1456.000000, 212.000000)">
                                <g transform="translate(48.000000, 0.000000)">
                                    <polygon points="13.5 0 13.5 6.75 20.25 6.75"></polygon>
                                    <path d="M13.5,8.4375 C12.5701875,8.4375 11.8125,7.6798125 11.8125,6.75 L11.8125,0 L1.6875,0 C0.7576875,0 0,0.7576875 0,1.6875 L0,25.3125 C0,26.244 0.7576875,27 1.6875,27 L18.5625,27 C19.494,27 20.25,26.244 20.25,25.3125 L20.25,8.4375 L13.5,8.4375 Z M6.75,23.625 L3.375,23.625 L3.375,18.5625 L6.75,18.5625 L6.75,23.625 Z M11.8125,23.625 L8.4375,23.625 L8.4375,15.1875 L11.8125,15.1875 L11.8125,23.625 Z M16.875,23.625 L13.5,23.625 L13.5,11.8125 L16.875,11.8125 L16.875,23.625 Z" id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <p>Generuj raport</p>
              </span>-->
              <span v-if="type !== 'trash'" class="button-module-table" :class="{'disabled' : historyMode || blocked }" @click="addProductToPage()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 448"><g><path d="m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/></g> </svg>
                <p>Nowy produkt</p>
              </span>
              <span v-if="type !== 'trash'" class="button-module-table" @click="copyPage()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-61 0 512 512"><g><path d="m180 210v-120h-180v422h300v-302zm30-111.300781v81.300781h81.300781zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m381.300781 90h-81.300781v-81.300781zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m90 0h180v116.398438l-56.398438-56.398438h-123.601562zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m390 120v302h-60v-245.601562l-56.398438-56.398438zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/></g> </svg>
                <p>Kopiuj</p>
              </span>
              <span v-if="type == 'trash'" class="button-module-table" :class="{'disabled' : historyMode || blocked }" @click="restoreProducts()">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve"><g><g>
                  <g>
                    <path d="M256,0H85.333C61.867,0,42.88,19.2,42.88,42.667L42.667,384c0,23.467,18.987,42.667,42.453,42.667h256.213    C364.8,426.667,384,407.467,384,384V128L256,0z M213.333,341.333c-43.733,0-81.173-26.347-97.707-64h36.48    c13.547,19.307,35.84,32,61.12,32c41.28,0,74.667-33.387,74.667-74.667c0-41.28-33.387-74.667-74.667-74.667    c-28.907,0-53.653,16.533-66.027,40.64l34.133,34.027H96v-85.333l27.733,27.733C142.72,147.627,175.68,128,213.333,128    C272.213,128,320,175.787,320,234.667S272.213,341.333,213.333,341.333z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  </g>
                </g></g> </svg>
                <p>Przywróć</p>
              </span>
              <span v-if="type != 'trash'" class="button-module-table" :class="{'disabled' : historyMode || blocked || selectedItems.length == 0 }" @click="massMovePopup = true">
                <svg viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Edycja-zlecenia-popup-przenoszenie-produktów" transform="translate(-1409.000000, -193.000000)" fill="#D3020C" fill-rule="nonzero">
                            <g id="transfer" transform="translate(1409.000000, 193.000000)">
                                <path d="M10.2220456,5.87088315 C10.2920249,5.93963969 10.386497,5.97401796 10.4774702,5.97401796 C10.5684433,5.97401796 10.6629155,5.93963969 10.7328948,5.87088315 C10.8763525,5.72993224 10.8763525,5.5099113 10.7328948,5.36896039 L9.98061683,4.62982756 L12.4893764,4.62982756 C13.9974313,4.62982756 15.2220699,5.83650488 15.2220699,7.31477054 L15.2220699,8.90304666 C15.2220699,9.09900281 15.3830224,9.25714286 15.5824635,9.25714286 C15.7819046,9.25714286 15.9428571,9.09900281 15.9428571,8.90304666 L15.9428571,7.31133271 C15.9428571,5.44115476 14.3928146,3.91475952 12.4858774,3.91475952 L9.97711786,3.91475952 L10.7293958,3.17906451 C10.8728535,3.0381136 10.8728535,2.81809267 10.7293958,2.67714176 C10.5859382,2.53619084 10.3620043,2.53619084 10.2185466,2.67714176 L8.85045039,4.02133216 C8.70699273,4.16228307 8.70699273,4.38230401 8.85045039,4.52325492 L10.2220456,5.87088315 Z" id="Path"></path>
                                <polygon id="Shape" points="9.98689511 9.98659955 17.2702477 9.98659955 17.2702477 17.2670023 9.98689511 17.2670023"></polygon>
                                <path d="M2.41753649,8.74285714 C2.21809535,8.74285714 2.05714286,8.90097686 2.05714286,9.09690782 L2.05714286,10.6884172 C2.05714286,12.5583548 3.60718538,14.0845538 5.51412257,14.0845538 L8.02288214,14.0845538 L7.27060416,14.8235916 C7.1271465,14.9645244 7.1271465,15.1845171 7.27060416,15.3254499 C7.34058351,15.3941976 7.43505563,15.4285714 7.52602878,15.4285714 C7.61700193,15.4285714 7.71147404,15.3941976 7.78145339,15.3254499 L9.14954961,13.9814322 C9.29300727,13.8404994 9.29300727,13.6205068 9.14954961,13.479574 L7.78145339,12.1355564 C7.63799573,11.9946236 7.41406182,11.9946236 7.27060416,12.1355564 C7.1271465,12.2764892 7.1271465,12.4964818 7.27060416,12.6374146 L8.02288214,13.3764524 L5.51412257,13.3764524 C4.00606765,13.3764524 2.78142909,12.1699302 2.78142909,10.6918546 L2.78142909,9.10034521 C2.77793012,8.89753948 2.61697763,8.74285714 2.41753649,8.74285714 Z" id="Path"></path>
                                <path d="M0.729752257,0.729752257 L8.01310489,0.729752257 L8.01310489,8.01310618 L0.729752257,8.01310618 C0.729752257,8.01664737 0.729752257,0.729752257 0.729752257,0.729752257 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </svg>
                <p>Przenieś</p>
              </span>
              <span class="button-module-table" :class="{'disabled' : historyMode || blocked }" @click="type !== 'trash' ? moveProductToTrash() : removeProducts()">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 443 443" style="enable-background:new 0 0 443 443;" xml:space="preserve"><g><g>
                  <path d="M321.785,38h-83.384V0H125.169v38H41.785v60h280V38z M155.169,30h53.232v8h-53.232V30z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  <path d="M295.142,214.31l5.66-86.31H62.769l19.016,290h114.172c-14.861-21.067-23.602-46.746-23.602-74.43   C172.355,274.43,226.849,217.779,295.142,214.31z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  <path d="M301.785,244.141c-54.826,0-99.43,44.604-99.43,99.429S246.959,443,301.785,443s99.43-44.604,99.43-99.43   S356.611,244.141,301.785,244.141z M355.961,376.533l-21.213,21.213l-32.963-32.963l-32.963,32.963l-21.213-21.213l32.963-32.963   l-32.963-32.963l21.213-21.213l32.963,32.963l32.963-32.963l21.213,21.213l-32.963,32.963L355.961,376.533z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                </g></g> </svg>
                <p>Usuń</p>
              </span>
            </div>
          </div>
        <b-container fluid>
          <div class="table--wrapper">
            <b-table
              class="app-table products-order-table module-table"
              :class="{'page-table' : type == 'page' || type == 'waitingRoom'}"
              ref="productTable"
              show-empty
              stacked="md"
              :items="products"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :backend-sorting="true"
              :sort-by="sortField"
              :sort-desc="sortDesc"
              @filtered="onFiltered"
              @row-dblclicked="editProduct"
              :tbody-tr-class="rowClass"
              :reRender="reRender"
              :busy="isBusy"
              hover>

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              
              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <template slot="HEAD_check" slot-scope="row">
                <div class="form-group">
                  <label class="checkbox checkbox--form" :class="{'disabled' : historyMode}"><input type="checkbox" @click="checkAll()" :checked="checkedAll"/><span class="checkmark"></span></label>
                </div>
              </template>
              
              <template slot="HEAD_images" slot-scope="row">
                <div class="form-group grup-for-icon" :class="{'active' : sortField == 'images'}" @click="sortDir('images')">
                  <img class="column-icon" src="../../assets/symbols/picture.svg"/>
                  <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'images'"></div>
                </div>
              </template>

              <template slot="HEAD_updatedAt" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'updatedAt'}" @click="sortDir('updatedAt')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'updatedAt'"></div>
                    </label>
                </div>
              </template>
              
              <template slot="check" slot-scope="row">
                <label class="checkbox checkbox--form checkbox-table" :class="{'disabled' : historyMode}"><input type="checkbox"  :checked="checkedAll" @click="checkboxes(row.item)"/><span class="checkmark"></span></label>
              </template>

              <template slot="HEAD_number" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'number'}" @click="sortDir('number')">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'number'"></div>
                  </label>
                </div>
              </template>

              <template slot="HEAD_name" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'name'}" @click="sortDir('name')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'name'"></div>
                    </label>
                </div>
              </template>

              <template slot="HEAD_producer" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'producer'}" @click="sortDir('producer')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'producer'"></div>
                    </label>
                </div>
              </template>

              <template slot="HEAD_salePrice" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'salePrice'}" @click="sortDir('salePrice')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'salePrice'"></div>
                    </label>
                </div>
              </template>

              <template slot="HEAD_hero" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'hero'}" @click="sortDir('hero')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'hero'"></div>
                    </label>
                </div>
              </template>

              <template slot="HEAD_page" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'page'}" @click="sortDir('page')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: !sortDesc, down: sortDesc }" v-if="sortField == 'page'"></div>
                    </label>
                </div>
              </template>
              
              <template slot="number" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div class="number-group" :class="[{'new-product' : row.item.historyNew}, historyChangeStatus(row.item, 'number')]">
                  {{row.item.number ? row.item.number : row.item.productNumber}}
                  <div @click="setActiveRow($event)" style="position:relative">
                    <div class="icon-mask" @click="row.toggleDetails"></div>
                    <svg :class="{'active' : activeRow ==  row.item.id}" class="arrow-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="100%" height="100%" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"
                    xml:space="preserve">
                    <path fill="#000" d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                      L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
                      c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
                    </svg>
                  </div>
                </div>
                </draggable>
              </template>

              <template slot="href" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div v-if="row.item.href" class="href-column">
                  <img class="name-icon" src="@/assets/symbols/graphic.svg" />
                </div>
                <div v-if="!row.item.href" class="href-column">
                  <img v-if="row.item.type.code == 'footer'" class="name-icon" src="@/assets/symbols/footer.svg" />
                  <img v-if="row.item.type.code == 'descriptive'" class="name-icon" src="@/assets/symbols/descriptive.svg" />
                  <img v-if="row.item.type.code == 'graphic'" class="name-icon" src="@/assets/symbols/graphic.svg" />
                  <img v-if="row.item.type.code == 'default'" class="name-icon" src="@/assets/symbols/default.svg" />
                  <img v-if="row.item.type.code == 'service'" class="name-icon" src="@/assets/symbols/service.svg" />
                  <img v-if="row.item.type.code == 'price_group'" class="name-icon" src="@/assets/symbols/price_group.svg" />
                </div>
                </draggable>
              </template>

              <template slot="name" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item, $event)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                  <div class="names-columns" :class="historyChangeStatus(row.item, 'name')">
                    {{row.item.name}}
                  </div>
                </draggable>
              </template>

              <template slot="producer" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div :class="historyChangeStatus(row.item, 'producer')" style="text-transform: uppercase">
                  {{row.item.producer}}
                </div>
                </draggable>
              </template>

              <template slot="images" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div class="images-column" :style="imagesInfoColor(row.item)" :class="historyChangeStatus(row.item, 'images')">
                  {{!row.item.href ? row.item.choosenImages + row.item.suggestedImages : ''}}
                  <img v-if="checkProductImagesStatus(row.item)" src="@/assets/symbols/exclamation-mark.svg">
                </div>
                </draggable>
              </template>

              <template slot="updatedAt" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div :class="historyChangeStatus(row.item, 'updatedAt')">
                  {{row.item.updatedAt}}
                </div>
                </draggable>
              </template>

              <template slot="salePrice" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div :class="historyChangeStatus(row.item, 'salePrice')">
                  {{ row.item.salePrice == 0 ? '' : row.item.salePrice}}
                </div>
                </draggable>
              </template>

              <template slot="hero" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div v-if="!row.item.href" :class="historyChangeStatus(row.item, 'isHero')">
                  <label class="checkbox checkbox--form" :class="{'disabled' : historyMode || blocked }"><input type="checkbox" class="isHeroCheck" :checked="row.item.checklistMap.isHero" @change="updateProduct(row.item)"/><span class="checkmark"></span></label>
                </div>
                </draggable>
              </template>

              <template slot="page" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div class="page-column" :class="historyChangeStatus(row.item, 'pageNumber')">
                  <div class="history-old-page">{{row.item.historyOldPage ? row.item.historyOldPage : ''}}</div>
                  <div v-if="!historyMode">{{row.item.page != 0 ? row.item.page : ''}}</div>
                  <div v-if="historyMode">{{row.item.pageNumber != 0 ? row.item.pageNumber : ''}}</div>
                </div>
                </draggable>
              </template>

              <template slot="comments" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div :class="historyChangeStatus(row.item, 'comment')">
                  <span v-if="row.item.comment" class="table-comment"><img src="../../assets/symbols/chat.svg"/></span>
                </div>
                </draggable>
              </template>

              <template slot="temp" slot-scope="row">
                <draggable :group="{name: 'dropOnPage', pull: 'clone', put: false}" dragClass="dragged-product" :list="products" :sort="false" @start="emitDraggedProduct(row.item)" @end="hideTrashArea()" :disabled="blocked ? blocked : historyMode">
                <div :class="historyChangeStatus(row.item, 'comment')">
                  <div v-if="!row.item.href && row.item.isTemporary" class="table-dot"></div>
                </div>
                </draggable>
              </template>

              <template slot="row-details" slot-scope="row">
                <div v-if="!row.item.href" class="details">
                  <div class="details__column">
                    <p>Nazwa produktu: <span>{{row.item.name}}</span></p>
                    <p>Nr artykułu w projekcie: <span>{{row.item.number}}</span></p>
                    <p>EAN: {{row.item.ean}}</p>
                  </div>
                  <div class="details__column">
                    <p>Opis produktu w bulletach: <span>{{row.item.longDescription}}</span></p>
                    <p>Opis produktu bez bulletów: <span>{{row.item.description}}</span></p>
                    <p>Uwagi dla Agencji: <span>{{row.item.comment}}</span></p>
                  </div>
                  <div class="details__column">
                    <p>Cena dotychczasowa: <span>{{row.item.currentPrice}}</span></p>
                    <p>Cena z Orange: <span>{{row.item.orangePrice}}</span></p>
                    <p v-if="!row.item.priceUnitValue">Cena sprzedaży: <span>{{row.item.salePrice}}</span></p>
                    <p v-if="row.item.priceUnitValue && row.item.priceUnitValue == 1">Cena od: <span>{{row.item.salePrice}}</span></p>
                    <p v-if="row.item.priceUnitValue && row.item.priceUnitValue == 2">Cena za sztukę: <span>{{row.item.salePrice}}</span></p>
                    <p v-if="row.item.priceUnitValue && row.item.priceUnitValue == 3">Cena za zestaw: <span>{{row.item.salePrice}}</span></p>
                  </div>
                </div>
                <div v-if="row.item.href" class="details details--images">
                  <div class="details__column details__column--image">
                    <div class="detail-image">
                      <img :src="row.item.href" :alt="row.item.name" />
                      <span class="name">
                      <div class="name--zoom icon-image" @click="displayImagePopup(row.item)">
                        <img src="@/assets/symbols/zoom-in.svg" alt="Powiększ zdjęcie" />
                      </div>
                    </span>
                    </div>
                  </div>
                  <div class="details__column">
                    <p>Nazwa: <span>{{row.item.name}}</span></p>
                    <p>Ocena: <span>{{row.item.quality}}</span></p>
                  </div>
                  <div class="details__column">
                    <p>Keywords: <span>{{row.item.keywords}}</span></p>
                  </div>
                </div>
              </template>
          
            </b-table>
          </div>
        </b-container>
        <b-row>
            <b-col class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="tableCount" 
                :per-page="perPage"
                class="my-0 float-right">
              </b-pagination>
            </b-col>
          </b-row>
        <div class="drop-zone-area">
          <draggable class="custom-drop-area" id="product-area" group="products" :list="addedProduct"  @change="addProductToList()">
            <h1>Upuść produkt</h1>
            <span>+</span>
          </draggable>
          <draggable class="custom-drop-area" id="image-area" group="images" :list="addedImage" @change="addImageToList()">
            <h1>Upuść zdjęcie</h1>
            <span>+</span>
          </draggable>
        </div>
      </div>
      <popup 
        v-if="warningPopup"
        title="Uwaga" 
        text="Czy na pewno chcesz usunąć produkty?" 
        cancelButton="Anuluj" 
        confirmButton="Usuń" 
        @confirmed="deleteConfirmation = true, deleteProduct()"
        @canceled="deleteConfirmation = false, warningPopup = false"/>

       <!-- <copyPopup 
        @canceled="copySinglePage = false; selectedItems = []; $parent.$parent.uncheckAllCheckboxes();"
        :pageId="pageId"
        :orderId="orderId"
        :selectedItems="selectedItems"
        :selectedPages="selectedPages"/> -->

        <copy v-if="copySinglePage"
        @cancel="copySinglePage = false; selectedItems = []; $parent.$parent.uncheckAllCheckboxes();"
        :pageId="pageId"
        :orderId="orderId"
        :selectedItems="selectedItems"
        :selectedPages="selectedPages"
        />

        <imagePopup v-if="showImagePopup" v-bind:image="imageToEnlarge"></imagePopup>
        <moveProductsPopup v-if="massMovePopup" :pages="pagesList" @choose="massMove($event); massMovePopup = false" @cancel="massMovePopup = false; selectedItems = []; $parent.$parent.uncheckAllCheckboxes();"/>
  </div>

</template>

<script>

import debounce from "lodash.debounce";
import popup from '@/components/blocks/popup';
import draggable from 'vuedraggable';
import copyPopup from '@/components/blocks/orderEdit/copyPopup.vue';
import _ from 'lodash';
import imagePopup from '@/components/blocks/product/imagePopup';
import { setTimeout } from 'timers';
import moveProductsPopup from '@/components/blocks/orderEdit/moveProductsPopup.vue';
import copy from '@/components/blocks/orderEdit/copy.vue';
import pageStatus from '@/components/blocks/orderEdit/pageStatus.vue';

export default {

  name: 'productsInOrder',
  components:{

    popup,
    draggable,
    copyPopup,
    imagePopup,
    moveProductsPopup,
    copy,
    pageStatus,

  },
  props:{

    orderId:{
      type: Number,
      default: 0
    },

    orderMain:{
      default: () => {}
    },

    type:{
      type: String,
      default: 'order'
    },

    pageId:{
      type: Number,
      default: 0,
    },

    pagesList:{
      type: Array,
      default: () => []
    },

    addSingle:{
      default: null,
    },

    historyMode:{
      type: Boolean,
      default: false,
    },

    blocked:{
      type: Boolean,
      default: false,
    },

    orderToCompare:{
      type: Object,
      default: () => {}
    },

    historyList:{
      type: Array,
      default: () => []
    },

    selectedPages:{
      type: Array,
    },

    historyId:{
      default: 0,
    },

    originalOrderId:{
      type: Number,
      default: 0,
    },

  },
  data () {

    return {

      title: 'Lista produktów',
      subTitle: 'w zleceniu',
      tableCount: 0,
      addedProduct: [],
      addedImage: [],
      numberToPage: 0,
      showImagePopup: false,
      imageToEnlarge: '',
      massMovePopup: false,

      reRender: 0,

      activeRow: 0,

      isBusy: false,
      fields: [

          {
            key: 'check', 
            label: '' ,
          },
          {
            key: 'number', 
            label: 'Nr artykułu',
          },
          {
            key: 'href', 
            label: '',
          },
          {
            key: 'name', 
            label: 'Nazwa produktu',
          },
          {
            key: 'producer', 
            label: 'Producent',
          },
          {
            key: 'images', 
            label: 'Liczba zdjęć',
          },
          {
            key: 'updatedAt', 
            label: 'Data aktualizacji',
          },
          {
            key: 'salePrice', 
            label: 'Cena sprzedaży',
          },
          {
            key: 'hero', 
            label: 'Hero',
          },
          {
            key: 'page', 
            label: 'Nr strony',
          },
          {
            key: 'comments', 
            label: '',
          },
          {
            key: 'temp', 
            label: '',
          },

        ],

      products: [],
      history_products: [],
      images: [],
      selectedItems:[],
      selectedItems_copy:[],
      itemsToCopy: [],
      warningPopup: false,
      copy_popup: false,
      deleteConfirmation: false,
      blockEditTimer: null,
      pageBlocked: false,
      copySinglePage: false,

      checkedAll: false,

      search:{
        field: '',
        number: '',
        name: '',
        producer: '',
        images: '',
        updatedAt: '',
      },

      totalRows: 1, // Do sprawdzenia dlaczego w koszu ta zmienna ustawiana jest na undefined
      currentPage: 1,
      perPage: 10,
      offset: 0,
      sortDesc: false,
      //sortDirection: 'ASC',
      sortField: 'number',
      filter: null,

    }

  },
  methods:{

    findPage(number){

      if(this.pageId !== 0 && this.pagesList){

        let page = this.pagesList.find(o => o.id == this.pageId);

        if(page && number) return page.number;
        if(page) return page;

      }

      if(number) return '';
      return {};

    },
    
    generateReport(){

      this.isBusy = true;

      const token = localStorage.getItem('auth_token');

      this.$http.get(`orders/${this.orderId}/export/products/in/order`, {
      headers: {

      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'

      }})
      .then(response => {

        const url = response.data;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();

        this.isBusy = false;

      })
      .catch(error =>{

        this.isBusy = false;
        console.error(error.response);

      })

    },

    sortDir(field){

      if(field != this.sortField){

        this.sortField = field; 
        this.sortDesc = false;
        this.manager();
        return;

      }
      
      //this.sortField = field;
      this.sortDesc = !this.sortDesc
      this.manager();

    },

    emitDraggedProduct(product, e){

      let number;

      number = product.number ? product.number : '';
      if(product.productNumber) number = product.productNumber;

      let html = `<p>${number}</p>`;
      let ghost = document.createElement("DIV");
      ghost.classList.add('ghost-label');
      ghost.style.position = 'absolute';
      ghost.innerHTML = html;
      document.body.appendChild(ghost)
      document.addEventListener('drag', e =>{
        let lab = document.querySelector('.ghost-label'); 
        lab.style.left = e.clientX + 5 + "px";  
        lab.style.top = e.clientY + "px";     
      });

      const zone = document.querySelectorAll('.dropZonePageTrash');

      if(zone){
        zone.forEach(zone =>{
          zone.style.display = 'block';
        })
      }

      this.$emit('draggedProduct', product);

    },

    hideTrashArea(){

      let ghost = document.querySelector('.ghost-label');
      document.body.removeChild(ghost);

      const zone = document.querySelectorAll('.dropZonePageTrash');

      if(zone){
        zone.forEach(zone =>{
          zone.style.display = 'none';
        })
      }

    },

    checkProductImagesStatus( product ) {
      if ( product.notAcceptedImage ) {
        return true;
      }

      if ( product.quality === '' ) {
        return true;
      }

      return false;

    },

    historyChangeStatus(item, key){

      if(item.historyChange){

        if(item.historyChange[key]){

          if(key == 'pageNumber'){

            return 'product-change product-change-page'

          }

          return 'product-change'

        }

      }

    },

    rowClass(item){

      if(item){

        if(item.historyDeleted){
          return 'deleted-product';
        }

        if(item.checklistMap){

          if(!item.checklistMap.examined && item.isTemporary){
            return 'product-not-verified-temp';
          }

          if(item.checklistMap.examined && item.isTemporary){
            return 'product-temp';
          }

          if(item.checklistMap.examined){
            return 'product-verified';
          }

        }

      }

    },

    addProductToPage(){

      const pages = this.$parent.order.orderPages;

      let communication = {
        pageId: this.pageId,
        pages: pages,
        orderId: this.orderId,
      }

      this.storeDataInStorage('OrderProduct', communication);
      this.$router.push('/product/add');

    },

    editProduct(row){

      if(row.historyNew) return;
      if(this.type == 'trash') return;

      const pages = this.$parent.order.orderPages;
      const find = this.pageId != 0 ? pages.find(x => x.id === this.pageId) : '';

      let pageNumber = row.page != 0 ? row.page : find.number;

      let communication = {
        pageId: this.pageId,
        orderId: this.orderId,
        page: pageNumber,
        pages: pages,
      }

      if(this.historyMode){

        let productToCompare = this.history_products.find(historyProduct => historyProduct.originalProduct.id === row.originalProduct.id);

        productToCompare ? productToCompare = productToCompare : productToCompare = {};

        communication['history'] = {
          currentProduct: row,
          productToCompare: productToCompare,
          historyList: this.historyList,
          historyId: this.historyId,
          originalOrderId: this.originalOrderId,
          productList: this.products,
        }

      }

      if(this.$parent.checkCentralUser(row.pageId) && !row.href || this.$parent.checkEditor() && !row.href){

        communication['preview'] = true;
          
        this.storeDataInStorage('OrderProduct', communication);
        this.$router.push(`/product/${row.id}/edit`);
        return;

      }

      if(!this.$parent.checkCentralUser() && !row.href && !this.$parent.checkEditor()){
          
        this.storeDataInStorage('OrderProduct', communication);
        this.$router.push(`/product/${row.id}/edit`);
        return;
 
      }

      if(row.href){

        this.displayImagePopup(row)
        return;

      }

    },

    updateProduct(product){

        if(product.type.id) product.type = product.type.id;
        product.checklistMap.isHero = !product.checklistMap.isHero;

        let checklistMap = {
          checklistMap: product.checklistMap,
        };

        this.isBusy = true;
        
        const token = localStorage.getItem('auth_token');

        this.$http.put(`products/${product.id}`, checklistMap, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }).then(response => {

          this.manager();
          //this.$refs.productTable.refresh();

        }).catch(error => {
          console.error(error);
          this.manager();
        })
    },

    copyPage(){

      this.copySinglePage = true;

    },

    setActiveRow(event){

      let e = event.target.parentElement.querySelector('svg')
      
      if(e.classList.contains('active')){

        e.classList.remove('active');
        return;

      }
      
      e.classList.add('active');

    },

    checkAll(){

      
      if(!this.checkedAll){

        let checks = document.querySelectorAll('.checkbox-table input[type="checkbox"]');
          for(var i =0; i< checks.length;i++){
              var check = checks[i];
              check.checked = true;
          }

        this.selectedItems = [];
        this.checkedAll = true;

        this.products.forEach(element => {

          if(!element.href){

            this.selectedItems.push({id: element.id, pageId: element.pageId, rowType: 'product'});

          }else{

            this.selectedItems.push({id: element.id, pageId: element.pageId, rowType: 'image'});

          }

        });

        return;

      }

      let checks = document.querySelectorAll('.checkbox-table input[type="checkbox"]');
          for(var i =0; i< checks.length;i++){
              var check = checks[i];
              check.checked = false;
      }

      this.checkedAll = false;
      this.selectedItems = [];

    },

    checkboxes(item){

      const id = item.id;
      const type = item.href ? 'image' : 'product';

      let obj = this.selectedItems.find(o => o.id === id && o.pageId == item.pageId);

      if(!obj){

        this.selectedItems.push({id: id, pageId: item.pageId, rowType: type});
        return;

      }

      this.selectedItems = this.selectedItems.filter(o => o.id !== id && o.pageId == item.pageId);

    },

    addProductToList(){

      if(!this.pageBlocked){

        let product = {
          product: this.addedProduct[0].id
        }

        const token = localStorage.getItem('auth_token');

        if(this.type == 'page'){

          this.$http.post(`order-pages/${this.pageId}/adds/products`, product, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              this.addedProduct = [];
              this.$parent.getOrder();
              this.getPageProducts();
              

            })
            .catch(error =>{

                console.error(error.response);
                this.addedProduct = [];

            })

        }

        if(this.type == 'order' || this.type == 'waitingRoom'){

          this.$http.post(`orders/${this.orderId}/products/${this.addedProduct[0].id}/waitings`, '', {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(() => {

              this.addedProduct = [];
              this.$parent.getOrder();  
              this.type == 'order' ?  this.getOrderProducts() :  this.getWaitingRoomProducts();     

            })
            .catch(error =>{

                console.error(error.response);
                this.addedProduct = [];

            })

        }

      }

    },

    addImageToList(){

      if(!this.pageBlocked){

        const token = localStorage.getItem('auth_token');

        if(this.type == 'page'){

          let image = {
            productImage: this.addedImage[0].id
          }

          this.$http.post(`order-pages/${this.pageId}/adds/products/images`, image, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              this.addedImage = [];
              this.$parent.getOrder();
              this.getPageProducts();
              

            })
            .catch(error =>{

                console.error(error.response);
                this.addedImage = [];

            })

        }

        if(this.type == 'order'){

          this.$http.post(`orders/${this.orderId}/products/${this.addedImage[0].id}/images/waitings`, {}, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              this.addedImage = [];
              this.$parent.getOrder();
              this.getOrderProducts();
              

            })
            .catch(error =>{

                console.error(error.response);
                this.addedImage = [];

            })

        }

      }

    },

    manager(){

      switch (this.type){

        case 'order':
          this.getOrderProducts();
          
        break;

        case 'page':
          this.getPageProducts();
          
        break;

        case 'waitingRoom':
          this.getWaitingRoomProducts();
        break;

        case 'trash':
          this.getTrashProducts();
        break;

        default:
          this.getOrderProducts();
          

      }

    },

    getOrderProducts(){

      if(!this.historyMode){

        this.isBusy = true;

        const token = localStorage.getItem('auth_token');

        this.$http.get(`orders/${this.orderId}/products`, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            const images = response.data.productImages;

            this.products = response.data.products;

            if(images){

              images.forEach(image => {
                image['salePrice'] = 0;
                this.products.push(image)
              });

            }

            this.totalRows  = this.products.length;
            this.tableCount = this.products.length;
            this.subTitle = 'w zleceniu';
            this.isBusy = false;

          })
          .catch(error =>{
            
            if(error.response.status === 401) {
              
              this.$router.push('/');

            }
            
            if(error.response.status === 400){

              this.products = [];
              this.totalRows = 0;
              this.isBusy = false;
              
            }else{

              console.error(error.response);
              this.loading = false;

            }

          })

          return;

      }

     
      setTimeout(()=>{
      this.products = [];
      this.images = [];

      const pages = this.$parent.order.orderPages;

      if(pages){
      
        pages.forEach(page => {

          if(page.products){

            page.products.forEach(product =>{
              this.products.push(product)
            })

          }

          if(page.productImages){

            page.productImages.forEach(image =>{
              this.images.push(image)
            })

          }
          
        });

      }else{
        return;
      }
     
      if ( this.images ) {
        this.totalRows = this.products.length + this.images.length;
        this.tableCount =  this.products.length + this.images.length;
      }

      this.subTitle = 'w zleceniu';
      this.isBusy = false;

      
      if(this.orderToCompare){
        this.compareProducts();
        this.compareImages();
      }
      
      }, 100)

    },

    getPageProducts(){

      if(!this.historyMode){
      
        const token = localStorage.getItem('auth_token')

        this.pageId = parseInt(this.pageId)

        this.$http.get(`order-pages/${this.pageId}/products`, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            const images = response.data.productImages;

            this.products = response.data.products;
            
            images.forEach(image => {
              this.products.push(image)
            });

            this.totalRows  = this.products.length;
            this.subTitle   = 'na stronie';
            this.tableCount = this.products.length;
            this.isBusy = false;

          })
          .catch(error =>{
            
            if(error.response.status === 401) {
              
              this.$router.push('/');

            }
            
            if(error.response.status === 400){

              this.products = [];
              this.totalRows = 0;
              this.isBusy = false;
              
            }else{

              console.error(error.response);
              this.loading = false;

            }

          })

          return;

      }

      setTimeout(()=>{

      this.products = [];
      this.images = [];

      const pages = this.$parent.order.orderPages;

      const page = pages.find(x => x.id === this.pageId);

      
      if(page.products){

        this.products = page.products;

      }

      if(page.productImages){

        this.images = page.productImages;

      } 

      if ( this.images ) {
        this.totalRows = this.products.length + this.images.length;
        this.tableCount =  this.products.length + this.images.length;
      }

      this.subTitle = 'na stronie';
      this.isBusy = false;
      
      this.comparePageProducts(page);
      this.comparePageImages(page);

      }, 200);

    },

    compareProducts(){

      let oldPages = [];

      if(this.orderToCompare){ 
        oldPages = this.orderToCompare.orderPages
      }else{
        return;
      };

      const oldProducts =[];

      oldPages.forEach(oldPage => {

        if(oldPage.products){

          oldPage.products.forEach(oldProduct =>{
            oldProducts.push(oldProduct)
          })

        }
        
      });

      this.history_products = oldProducts;

      this.products.forEach(thisProduct => {

        if(!thisProduct.xinetId){
        
          if(thisProduct.historyDeleted)  thisProduct.historyDeleted = false;
          if(thisProduct.historyChange)  thisProduct.historyChange = false;
          if(thisProduct.historyNew)  thisProduct.historyNew = false;

          const sameProduct = oldProducts.find(oldProduct => oldProduct.originalProduct.id === thisProduct.originalProduct.id);

          if(sameProduct){

            let diff =_.reduce(thisProduct, (result, value, key) => _.isEqual(value, sameProduct[key]) ? result : result.concat(key), [])

            if(diff.length > 0){

              let changes = {};

              diff.forEach(diff =>{

                changes[diff] = true;

                if(diff == 'pageNumber'){

                  thisProduct['historyOldPage'] = sameProduct.pageNumber;

                }

              })

              thisProduct['historyChange'] = changes;
              this.reRender++;
              return;

            }

          }else{

            thisProduct['historyNew'] = true;
            this.reRender++;

          }

        }
            
      });

      //Sprawdzenie, czy produkt został usunięty

      oldProducts.forEach(oldProduct => {

        if(oldProducts.historyDeleted)  oldProducts.historyDeleted = false;
        if(oldProducts.historyChange)  oldProducts.historyChange = false;
        if(oldProducts.historyNew)  oldProducts.historyNew = false;

        const old = this.products.find(product => product.originalProduct.id === oldProduct.originalProduct.id);

        if(!old){

          oldProduct['historyDeleted'] = true;
          this.products.push(oldProduct);

          this.reRender++;
          return;

        }

      })

    },

    comparePageProducts(thisPage){

      let oldPages = [];

      if(this.orderToCompare){ 
        oldPages = this.orderToCompare.orderPages
      }else{
        return;
      };

      const samePage = oldPages.find(oldPage => oldPage.originalPage.id === thisPage.originalPage.id);

      if(samePage){

        if(samePage.products){

          //Sprawdzenie, czy produkt jest nowy

          this.products.forEach(thisProduct => {

            if(!thisProduct.xinetId){

              if(thisProduct.historyDeleted)  thisProduct.historyDeleted = false;
              if(thisProduct.historyChange)  thisProduct.historyChange = false;
              if(thisProduct.historyNew)  thisProduct.historyNew = false;

              const sameProduct = samePage.products.find(oldProduct => oldProduct.originalProduct.id === thisProduct.originalProduct.id);

              if(sameProduct){

                let diff =_.reduce(thisProduct, (result, value, key) => _.isEqual(value, sameProduct[key]) ? result : result.concat(key), [])

                if(diff.length > 0){

                  let changes = {};

                  diff.forEach(diff =>{

                    changes[diff] = true;

                  })

                  thisProduct['historyChange'] = changes;
                  this.reRender++;
                  return;

                }

              }else{

                thisProduct['historyNew'] = true;
                this.reRender++;

              }

            }
            
          });

          //Sprawdzenie, czy produkt został usunięty

           samePage.products.forEach(oldProduct => {

            if(oldProduct.historyDeleted)  oldProduct.historyDeleted = false;
            if(oldProduct.historyChange)  oldProduct.historyChange = false;
            if(oldProduct.historyNew)  oldProduct.historyNew = false;

             const old = this.products.find(product => product.originalProduct.id === oldProduct.originalProduct.id);

             if(!old){

               oldProduct['historyDeleted'] = true;
               this.products.push(oldProduct);
               this.reRender++;
               return;

             }

           })

        }else{

          this.products.forEach(thisProduct => {

            if(thisProduct.historyDeleted)  thisProduct.historyDeleted = false;
            if(thisProduct.historyChange)  thisProduct.historyChange = false;
            if(thisProduct.historyNew)  thisProduct.historyNew = false;

            thisProduct['historyNew'] = true;
            this.reRender++;

          })

        }

      }else{

        this.products.forEach(thisProduct => {

            if(thisProduct.historyDeleted)  thisProduct.historyDeleted = false;
            if(thisProduct.historyChange)  thisProduct.historyChange = false;
            if(thisProduct.historyNew)  thisProduct.historyNew = false;

            thisProduct['historyNew'] = true;
            this.reRender++;

          })

      }

    },

    compareImages(){

      let oldPages = [];

      if(this.orderToCompare){ 
        oldPages = this.orderToCompare.orderPages
      }else{
        return;
      };
      let oldImages =[];

      oldPages.forEach(oldPage => {

        if(oldPage.productImages){

          oldPage.productImages.forEach(oldImage =>{
            oldImages.push(oldImage)
          })

        }
        
      });

      this.images.forEach(thisImage => {

        if(thisImage.historyDeleted)  thisImage.historyDeleted = false;
        if(thisImage.historyChange)  thisImage.historyChange = false;
        if(thisImage.historyNew)  thisImage.historyNew = false;

        const sameImage = oldImages.find(oldImage => oldImage.xinetId === thisImage.xinetId);

        if(sameImage){

          let diff =_.reduce(thisImage, (result, value, key) => _.isEqual(value, sameImage[key]) ? result : result.concat(key), [])

          if(diff.length > 0){

            let changes = {};

            diff.forEach(diff =>{

              changes[diff] = true;

            })

            thisImage['historyChange'] = changes;
            this.pushImageToProducts(thisImage)
            this.reRender++;
            return;

          }

          this.pushImageToProducts(thisImage)
          this.reRender++;
          return;

        }else{

          thisImage['historyNew'] = true;
          this.pushImageToProducts(thisImage)
          this.reRender++;

        }
            
      });

      //Sprawdzenie, czy produkt został usunięty

      oldImages.forEach(oldImage => {

        if(oldImages.historyDeleted)  oldImages.historyDeleted = false;
        if(oldImages.historyChange)  oldImages.historyChange = false;
        if(oldImages.historyNew)  oldImages.historyNew = false;

        const old = this.images.find(image => image.xinetId === oldImage.xinetId);

        if(!old){

          oldImage['historyDeleted'] = true;
          this.pushImageToProducts(oldImage)
          this.reRender++;
          return;

        }

      })

    },

    pushImageToProducts(thisImage){

      const check = this.products.find(product => product.xinetId === thisImage.xinetId);

      if(!check){
        this.products.push(thisImage);
      }

    },

    comparePageImages(thisPage){

      let oldPages = [];

      if(this.orderToCompare){ 
        oldPages = this.orderToCompare.orderPages
      }else{
        return;
      };

      const samePage = oldPages.find(oldPage => oldPage.originalPage.id === thisPage.originalPage.id);

      if(samePage){

        if(samePage.productImages){

          let oldImages =[];

         samePage.productImages.forEach(oldImage =>{
            oldImages.push(oldImage)
          })

          //Sprawdzenie, czy produkt jest nowy

          this.images.forEach(thisImage => {

            if(thisImage.historyDeleted)  thisImage.historyDeleted = false;
            if(thisImage.historyChange)  thisImage.historyChange = false;
            if(thisImage.historyNew)  thisImage.historyNew = false;

            const sameImage = oldImages.find(oldImage => oldImage.xinetId === thisImage.xinetId);

            if(sameImage){

              let diff =_.reduce(thisImage, (result, value, key) => _.isEqual(value, sameImage[key]) ? result : result.concat(key), [])

              if(diff.length > 0){

                let changes = {};

                diff.forEach(diff =>{

                  changes[diff] = true;

                })

                thisImage['historyChange'] = changes;
                this.pushImageToProducts(thisImage)
                this.reRender++;
                return;

              }

              this.pushImageToProducts(thisImage)
              this.reRender++;
              return;

            }else{

              thisImage['historyNew'] = true;
              this.pushImageToProducts(thisImage)
              this.reRender++;

            }
            
          });

          //Sprawdzenie, czy produkt został usunięty

           samePage.productImages.forEach(oldImage => {

            if(oldImage.historyDeleted)  oldImage.historyDeleted = false;
            if(oldImage.historyChange)  oldImage.historyChange = false;
            if(oldImage.historyNew)  oldImage.historyNew = false;

             const old = this.images.find(image => image.xinetId === oldImage.xinetId);

             if(!old){

               oldImage['historyDeleted'] = true;
               this.pushImageToProducts(oldImage)
               this.reRender++;
               return;

             }

           })

        }else{

          this.images.forEach(thisImage => {

            if(thisImage.historyDeleted)  thisImage.historyDeleted = false;
            if(thisImage.historyChange)  thisImage.historyChange = false;
            if(thisImage.historyNew)  thisImage.historyNew = false;

            thisImage['historyNew'] = true;
            this.pushImageToProducts(thisImage)
            this.reRender++;

          })

        }

      }else{

        this.products.forEach(thisImage => {

            if(thisImage.historyDeleted)  thisImage.historyDeleted = false;
            if(thisImage.historyChange)  thisImage.historyChange = false;
            if(thisImage.historyNew)  thisImage.historyNew = false;

            thisImage['historyNew'] = true;
            this.pushImageToProducts(thisImage)
            this.reRender++;

          })

      }

    },

    getWaitingRoomProducts(){

      if(!this.historyMode){

        this.$parent.$refs.orderPages.getOrderComments();

        this.isBusy = true;

        const token = localStorage.getItem('auth_token');

        this.$http.get(`orders/${this.orderId}/waitings`, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            const images = response.data.productImages;

            this.products = response.data.products;

            images.forEach(image => {
              this.products.push(image)
            });

            this.totalRows = response.data.total;
            this.tableCount =  this.products.length;
            this.subTitle = 'w poczekalni';
            this.isBusy = false;

          })
          .catch(error =>{
            
            if(error.response.status === 401) {
              
              this.$router.push('/');

            }
            
            if(error.response.status === 400 || error.response.status === 404){

              this.products = [];
              this.totalRows = 0;
              this.isBusy = false;
              
            }else{

              console.error(error.response);
              this.loading = false;

            }

          })

      }

    },

    getTrashProducts(){

      if(!this.historyMode){
      
        this.$parent.$refs.orderPages.getOrderComments();

        this.isBusy = true;

        const token = localStorage.getItem('auth_token');

        this.$http.get(`orders/${this.orderId}/baskets`, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            const images = response.data.productImages;

            this.products = response.data.products;

            images.forEach(image => {
              this.products.push(image)
            });
            
            this.totalRows = response.data.total;
            this.tableCount =  this.products.length;
            this.subTitle = 'w koszu';
            this.isBusy = false;

          })
          .catch(error =>{
            
            if(error.response.status === 401) {
              
              this.$router.push('/');

            }
            
            if(error.response.status === 400 || error.response.status === 404){

              this.products = [];
              this.totalRows = 0;
              this.isBusy = false;
              
            }else{

              console.error(error.response);
              this.loading = false;

            }

          })

      }

    },

    moveProductToTrash(){

      let products = this.selectedItems.filter(o => o.rowType !== 'image');
      let images = this.selectedItems.filter(o => o.rowType !== 'product');

     if(!this.pageBlocked){
      
      if(products.length > 0){
      
          this.isBusy = true;
          const token = localStorage.getItem('auth_token');

          let toMove = {

            products: products
            
          }

          let endpoint;

          if(this.pageId != 0 && this.type == 'page'){

            endpoint = `order-pages/${this.pageId}/products/intos/baskets`;

          }else if (this.pageId == 0 && this.type == 'waitingRoom'){

            endpoint = `orders/${this.orderId}/products/intos/baskets`;

          }else if (this.pageId == 0 && this.type == 'order'){

            endpoint = `orders/${this.orderId}/orders/intos/baskets`;

          }

          this.$http.post(endpoint, toMove, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.isBusy = false;
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.$parent.getOrder();
              this.checkedAll = false;

            })
            .catch(error =>{

              console.error(error.response);
              this.isBusy = false;

            })

        }

        if(images.length > 0){

          let rawImages = [];

          images.forEach(image =>{
            rawImages.push({id: image.id})
          })
      
          this.isBusy = true;
          const token = localStorage.getItem('auth_token');

          let toMove = {

            productImages: images
            
          }

          let endpoint;

          if(this.pageId != 0 && this.type == 'page'){

            endpoint = `order-pages/${this.pageId}/products/images/intos/baskets`;

          }else if (this.pageId == 0 && this.type == 'waitingRoom'){

            endpoint = `orders/${this.orderId}/products/images/intos/baskets`;

          }else if (this.pageId == 0 && this.type == 'order'){

            endpoint = `orders/${this.orderId}/images/intos/baskets`;

          }

          this.$http.post(endpoint, toMove, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.isBusy = false;
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.$parent.getOrder();
              this.checkedAll = false;

            })
            .catch(error =>{

              console.error(error.response);
              this.isBusy = false;

            })

        }
          
      }

    },

    moveProductToWaitingRoom(){

      let products = this.selectedItems.filter(o => o.rowType !== 'image');
      let images = this.selectedItems.filter(o => o.rowType !== 'product');

     if(!this.pageBlocked){
      
      if(products.length > 0){
      
          const token = localStorage.getItem('auth_token');

          let toMove = {

            products: products
            
          }

          let endpoint;

          if(this.pageId != 0 && this.type == 'page'){

            this.isBusy = true;

            endpoint = `orders/${this.orderId}/waitings/${this.pageId}/adds`;

            this.$http.post(endpoint, toMove, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.$parent.getOrder();
              this.checkedAll = false;

            })
            .catch(error =>{

              console.error(error.response);

            })

          }

          if(this.pageId == 0 && this.type == 'order'){

            this.isBusy = true;

            products.forEach(product =>{

              if(product.pageId == 0) return;

              let moveItem = {
                products: [product]
              }
            
              endpoint = `orders/${this.orderId}/waitings/${product.pageId}/adds`;

              this.$http.post(endpoint, moveItem, {
              headers: {

              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'

              }})
              .then(response => {
              })
              .catch(error =>{

                console.error(error.response);

              })
            
            })

            this.$parent.getOrder();
            this.manager();
            this.selectedItems = [];
            this.$parent.$parent.uncheckAllCheckboxes();
            this.checkedAll = false;

          }

        }

        if(images.length > 0){

          let rawImages = [];

          images.forEach(image =>{
            rawImages.push({id: image.id})
          })
      
          const token = localStorage.getItem('auth_token');

          let toMove = {

            productImages: images
            
          }

          let endpoint;

          if(this.pageId != 0 && this.type == 'page'){

            this.isBusy = true;

            endpoint = `orders/${this.orderId}/waitings/${this.pageId}/images/adds`;

            this.$http.post(endpoint, toMove, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.$parent.getOrder();
              this.checkedAll = false;

            })
            .catch(error =>{

              console.error(error.response);

            })

          }
          
          if (this.pageId == 0 && this.type == 'order'){

            this.isBusy = true;

            images.forEach(image =>{

              if(image.pageId != 0){
              
                let moveItem = {
                  productImages: [image]
                }
                    
                endpoint = `orders/${this.orderId}/waitings/${image.pageId}/images/adds`;

                this.$http.post(endpoint, moveItem, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'

                }})
                .then(response => {
    

                })
                .catch(error =>{

                  console.error(error.response);

                })

              }
            
            })

            this.selectedItems = [];
            this.isBusy = false;
            this.manager();
            this.$parent.$parent.uncheckAllCheckboxes();
            this.$parent.getOrder();
            this.checkedAll = false;

          }

        }
          
      }

    },

    removeProducts(){

      if(!this.pageBlocked){

        let products = this.selectedItems.filter(o => o.rowType !== 'image');
        let images = this.selectedItems.filter(o => o.rowType !== 'product');

        this.isBusy = true;
        const token = localStorage.getItem('auth_token');

        if(products.length > 0){
        
          let toMove = {

            products: this.selectedItems
            
          }

          this.$http.delete(`order-pages/${this.orderId}/remove/product`,{
            data: toMove,
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.isBusy = false;
              this.$parent.getOrder();
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.getTrashProducts();

            })
            .catch(error =>{

              console.error(error.response);
              this.isBusy = false;

              this.selectedItems = [];
              this.isBusy = false;
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.getTrashProducts();
              this.$parent.getOrder();

            })

        }

        if(images.length > 0){
        
          let toMove = {

            productImages: this.selectedItems
            
          }

          this.$http.delete(`order-pages/${this.orderId}/remove/product/images`,{
            data: toMove,
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {
              
              this.selectedItems = [];
              this.isBusy = false;
              this.$parent.getOrder();
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.getTrashProducts();

            })
            .catch(error =>{

              console.error(error.response);
              this.isBusy = false;

              this.selectedItems = [];
              this.isBusy = false;
              this.manager();
              this.$parent.$parent.uncheckAllCheckboxes();
              this.getTrashProducts();
              this.$parent.getOrder();

            })

        }

      }

    },

    restoreProducts(){

      let products = this.selectedItems.filter(o => o.rowType !== 'image');
      let images = this.selectedItems.filter(o => o.rowType !== 'product');

     if(!this.pageBlocked){
      
        this.isBusy = true;
        const token = localStorage.getItem('auth_token');

        let toMove = {

          products: products,
          images: images
          
        }

        this.$http.post(`legal-sentences/restores/products`, toMove, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {
          
          this.selectedItems = [];
          this.isBusy = false;
          this.manager();
          this.$parent.$parent.uncheckAllCheckboxes();
          this.$parent.getOrder();
          this.checkedAll = false;

        })
        .catch(error =>{

          console.error(error.response);
          this.isBusy = false;

        })    
          
      }

    },

    massMove(page){

      if(!page){
        this.moveProductToWaitingRoom();
        return;
      }

      let products = this.selectedItems.filter(o => o.rowType !== 'image');
      let images = this.selectedItems.filter(o => o.rowType !== 'product');

      const token = localStorage.getItem('auth_token');

      if(!this.pageBlocked){
      
        if(products.length > 0){

          let orderProducts = {
              products:[]
            }

          let pageProducts = {
              products:[]
            }

          products.forEach(product =>{

            if(product.pageId == 0){

              orderProducts.products.push(product);

            }else{

              pageProducts.products.push(product);

            }

          });

          if(orderProducts.products.length > 0){

            this.$http.post(`orders/${this.orderId}/waitings/${page.id}/removes`, orderProducts, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
            }).then(response => {

              this.$parent.getOrder();
              this.manager();
              this.selectedItems = [];
              this.$parent.$parent.uncheckAllCheckboxes();
              this.checkedAll = false;

            }).catch(error =>{

              console.error(error.response);
              this.selectedItems = [];
              this.$parent.$parent.uncheckAllCheckboxes();
              this.checkedAll = false;

            })

          }

          if(pageProducts.products.length > 0){

            let i = 0

            pageProducts.products.forEach(product =>{

              i++
            
              this.$http.put(`order-pages/${product.pageId}/moves/${page.id}/tos/${product.id}/other/page`,{fakeObj: ''}, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
              }).then(response => {

                if(i >= pageProducts.products.length){
                  this.$parent.getOrder();
                  this.manager();
                  this.selectedItems = [];
                  this.$parent.$parent.uncheckAllCheckboxes();
                  this.checkedAll = false;
                }

              }).catch(error =>{

                console.error(error.response);

              })
            
            })

          }

        }

        if(images.length > 0){

          let orderImages = {
            productImages:[]
          }

          let pageImages = {
            productImages:[]
          }

          images.forEach(image =>{

            if(image.pageId == 0){

              orderImages.productImages.push(image);

            }else{

              pageImages.productImages.push(image);

            }

          });

          if(orderImages.productImages.length > 0){

            this.$http.post(`orders/${this.orderId}/waitings/${page.id}/images/removes`, orderImages, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
            }).then(response => {

              this.$parent.getOrder();
              this.manager();
              this.selectedItems = [];
              this.$parent.$parent.uncheckAllCheckboxes();
              this.checkedAll = false;

            }).catch(error =>{

              console.error(error.response);
              this.selectedItems = [];
              this.$parent.$parent.uncheckAllCheckboxes();
              this.checkedAll = false;

            })

          }

          if(pageImages.productImages.length > 0){

            let i = 0;

            pageImages.productImages.forEach(image =>{

              i++

              let singleImage ={
                productImages:[image],
              }
            
              this.$http.post(`order-pages/${image.pageId}/moves/${page.id}/images`, singleImage, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
              }).then(response => {

                if(i >= pageImages.productImages.length){
                  this.$parent.getOrder();
                  this.manager();
                  this.selectedItems = [];
                  this.$parent.$parent.uncheckAllCheckboxes();
                  this.checkedAll = false;
                }

              }).catch(error =>{

                console.error(error.response);

              })
            
            })

          }

        }
          
      }

    },

    pageChange (page) {

      this.currentPage = page
      this.offset = ((this.currentPage - 1) * parseInt(this.perPage))
      
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    blockEdit(){

      if(!this.historyMode){

        const token = localStorage.getItem('auth_token');

        const user = this.$parent.$parent.$refs.head.user ? this.$parent.$parent.$refs.head.user.id : '';

        this.$http.post(`order-pages/${this.pageId}/blocks/${user}`, {fakeObject: ''}, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              console.log('blokuje edycję')
              
              window.clearTimeout(this.blockEditTimer);

              this.blockEditTimer = window.setTimeout(() => {

                this.blockEdit();

              },10000*6);

            })
            .catch(error =>{

              console.error(error.response);

            })

      }

    },

    isPageBlocked(){

      if(!this.historyMode){

        this.pageBlocked = true;

        const token = localStorage.getItem('auth_token');

        const user = `${this.$parent.$parent.$refs.head.user.name} ${this.$parent.$parent.$refs.head.user.surname}` ;

        this.$http.get(`order-pages/${this.pageId}/check/block`, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              const checkUser = response.data.blockByUser == user;

              if(response.data.isBlocked && !checkUser){

                this.$emit('pageBlocked', response.data.blockByUser);
                this.pageBlocked = true;
                console.log('zablokowana strona');
                return;

              }

              this.$emit('pageBlocked', '');
              this.blockEdit();
              this.pageBlocked = false;
              return;

            })
            .catch(error =>{

              console.error(error.response);

            })

      }

    },

    imagesInfoColor(product){

      if(product.choosenImages > 0){

        return 'color: #2ECC71;';

      }

      if(product.choosenImages == 0 && product.suggestedImages > 0){

        return 'color: #f7ba5a;';

      }

      if(product.choosenImages == 0 && product.suggestedImages == 0){

        return 'color: #adacac;';

      }

    },

    displayImagePopup(image) {
      this.showImagePopup = true;
      this.imageToEnlarge = image;
    },

  },
  watch:{

    orderId: function(){

      setTimeout(()=>{

        if (localStorage.getItem('selectOrderPage')){
          this.clearStorage('selectOrderPage');
          return;
        }

        this.getOrderProducts();
      }, 1000)
      
    },

    orderToCompare: function(){

      if(this.type == 'order' || this.type == 'page'){

        if(this.orderToCompare){

          setTimeout(()=>{
          this.compareProducts();
          this.compareImages();
          }, 1000)
        }

      }

    },

    type: function(){

      this.manager();
      this.checkedAll = false;

    },

    pageId: function(){

      this.manager();
      this.checkedAll = false;
      this.$parent.checkCentralUser();

    },

    addSingle: function(){

      this.addedProduct.push(this.addSingle);
      this.addProductToList();

    },

    blocked: function(){

      this.blocked ? this.pageBlocked = true : this.pageBlocked = false;

    },

    products(){
      this.products.forEach(product=>{
        product.images =  product.choosenImages + product.suggestedImages
        product.hero = product.checklistMap ? product.checklistMap.isHero : false;
      })

    }

  },
  mounted(){

    this.blocked ? this.pageBlocked = true : this.pageBlocked = false;

  },
};
</script>

<style lang="scss">

.view-data__header--module {
      margin-bottom: 5px !important;
      padding-top:5px !important;
  & h1{
    font-size: 14px !important;
  }
}

.copy-product-background{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: rgba(172, 172, 172, 0.411);
}

.copy-product{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:30%;
    padding:20px;
    z-index: 1000;
    background:#fff;
    border:1px solid #d3020c;

    &__title{
      width:100%;
      margin-bottom: 20px;
    }

    &__body{
      width:100%;
    }

    &__footer{
        display:flex;
        width:100%;
        justify-content: space-around;
        padding: 10px 0px;
    }
}

.module-table {
  table-layout: fixed; 
  border-spacing: 10rem 0rem !important;

  thead th {
      padding: 0.8rem 1rem !important;

      &:nth-child(1){
          width: 4% !important;
      }

      &:nth-child(3){
          width: 4% !important;
      }

      &:nth-child(5){
          width: 10% !important;
      }

      &:nth-child(6){
          width: 5% !important;
      }

      &:nth-child(7){
          width: 13% !important;
      } 
      
      &:nth-child(8){
          width: 13% !important;
      }

      &:nth-child(9){
          width: 5% !important;
      }

      &:nth-child(10){
          width: 8% !important;
      }

      &:nth-child(11){
          width: 4% !important;
      }

      &:nth-child(12){
          width: 3% !important;
      }

      &::after{
        content: '' !important;
      }
  }

  &.page-table{

    thead th {

      &:nth-child(10){
          width:0.1% !important;
          opacity:0;
      }
    }
  }

  .b-table-details td{
    padding: 0;
  }
}

.column-icon{
  display:block;
  width:100%;
  //margin-top:-30%;
  max-width: 25px;
}

.grup-for-icon{
  display:flex;
  align-items: center;
  height:100%;
}

.page-column{
  display:flex;
}

.href-column{
  display:flex;
  align-items: center;
  justify-content: center;
  width:100%;
  height: 100%;

  & img{
    opacity: 0.5;
    display:block;
    width:25px !important;
    height:25px !important;
    min-width:25px !important;
    min-height:25px !important;
  }
}

.history-old-page{
  margin-right:5px;
  margin-left:-5px;
  padding: 0px 5px;
  position:relative;
  display:none;
}

.history-old-page::after{
  position: absolute;
  content: '';
  width:100%;
  height:1px;
  top:50%;
  left:0px;
  background: #EE3338;
  z-index: 1;
}

.product-change-page .history-old-page{
  display:block;
}

.button-module-table{
  display:flex;
  flex-direction: column;
  align-items: center;
  margin:0px 10px;

  & svg{
    width:20px;
    height:20px;
  }

  & svg path{
    fill: #d3020c;
  }

  & p{
    width:100%;
    margin:0;
    font-size: 10px;
    margin-top:5px;
  }

  & .add-icon{
    color:#d3020c;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin:0;
    padding: 0;
  }
}

.add-comment{
  position:fixed;
  display:flex;
  align-items: center;
  justify-content: center;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(172, 172, 172, 0.411);
}

.add-comment-popup{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:30%;
    padding:20px;
    z-index: 100;
    background:#fff;
    border:1px solid red;

    & h1 {
      margin: 10px 0px;
    }

    & textarea{
      width:80%;
      height:100px;
      margin:5% 0%;
    }

    &__footer{
      display:flex;
      justify-content: space-between;
      align-items: center;
      width:80%;
    }
}

.images-column{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700 !important;
  font-size: 12px;
}

.names-columns{
  display: flex;
  align-items: center;

  & img{
    opacity: 0.5;
    margin-right: 5px;
    display:block;
    width:25px !important;
    height:25px !important;
    min-width:25px !important;
    min-height:25px !important;
  }
}

.table-comment{
  & img{
    display:block;
    opacity: 0.5;
    width: 100%;
    max-width: 23px;
  }
}

.button-group{

  & span{
    cursor:pointer;
  }
}

.bolded{
  font-weight: 700;
}

.details{
  display:grid;
  width:100%;
  grid-template-columns: 33% 33% 33%;
  grid-column-gap: 1%;
  background:#fff;
  padding: 10px;
  font-size: 12px;

  &--images{
    grid-template-columns: 16% 43% 40%;
  }

  &__column{
    display:flex;
    flex-direction: column;
    justify-content: space-between;

    & span{
      font-weight: 700;
    }

    & p{
      min-height: 50px;
    }

    &--image{
      flex-direction: row-reverse
    }
  }
}

.detail-image{
  display:flex;
  position:relative;
  justify-content: center;
  align-items: center;
  width:50px;
  height:50px;
  border: 1px #000 solid;
  margin-right: 15%;

  & img{
    display:block;
    max-width:100%;
    max-height:100%;
  }
}

.number-group{
  display:flex;
  justify-content: space-between;

  & svg{
    width:10px;
    height:10px;
    transform: rotate(180deg);
  }

  & .arrow-icon{

    &.active{
      transform: rotate(90deg);
      
      & path{
        fill:red;
      }
    }
  }
}

.icon-mask{
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index: 20;
}


//history colors

.new-product{
  color:#2ECC71
}

.deleted-product td{
  position:relative;
  opacity: 0.5;
  background:#F5F5F5 !important;
}

.deleted-product td::after{
  position: absolute;
  content: '';
  width:100%;
  height:1px;
  top:50%;
  left:0px;
  background: #000000;
  z-index: 1;
}

.deleted-product td{

  &:first-child::after{
    width:50%;
    right:0;
    left:auto;
  }

  &:last-child::after{
    width:50%;
  }
}

.product-change{
  color:#EE3338 !important;
}

.product-not-verified-temp td{
  //background-color: #E5E9FF !important;

  & .details{
    background:none;
  }
}

.product-verified td{
  background-color: #e1f8ea  !important;

  & .details{
    background:none;
  }
}

.product-temp td{
  background-color: #e1f8ea !important;

  & .details{
    background:none;
  }
}

.table-dot{
  width:10px;
  height:10px;
  border-radius: 50%;
  background-color: #F7BA5A !important;
}

.drop-zone-area{
  display:flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background:rgba(255, 255, 255, 0.664);
  z-index: 10;
  visibility: hidden;
}

.custom-drop-area{
  position: absolute;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 3px rgb(117, 117, 117) dashed;
  z-index: 1;
  left: 0;
  top: 0;

  & span{
    font-size: 36px;
    font-weight: 700;
  }
}

#product-area{
  visibility: hidden;
}

#image-area{
  visibility: hidden;
}

.name {
      position: absolute;
      bottom: -9px;
      left: -7px;
      color: #000000; 
      font-size: 7px; 
      letter-spacing: 0.07px; 
      line-height: 17px;
      padding: 0px 10px;
      background-color: #ffffff;
      border-radius: 5px;
      min-width: 70%;
}

.icon-image{
  display: flex;
  justify-content: center;
  align-items: center;
}

.dragged-product{
  background: transparent;
  color: transparent !important;
}

.ghost-label{
  min-height: 40px;
  display: flex;
  align-items: center;
  background-image: url('../../assets/symbols/box.svg');
  background-size: 20px;
  background-position: left;
  background-repeat: no-repeat;
  opacity:0.7;

  & p{
    margin:0px;
    margin-left: 25px;
    font-weight: 700;
  }
}

.view-data__header--module{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-status-container{
  display:flex;
  align-items: center;

  p{
    margin:0;
    padding-right: 10px;
    white-space: nowrap;
  }
}

</style>